<!-- 用户列表 -->
<template>
  <div>
    <!-- 标题 -->
    <div class="page-title">用户列表</div>

    <div
      style="
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin: 10px 0 5px;
        position: sticky;
        left: 30px;
        z-index: 5;
      "
    >
      <div class="screen-box">
        <div class="screen-label">用户ID</div>
        <a-input
          v-model="r_id"
          allowClear
          placeholder="请输入用户ID"
          style="width: 200px"
        />
      </div>

      <div class="screen-box">
        <div class="screen-label">用户名称</div>
        <a-input
          v-model="r_name"
          allowClear
          placeholder="请输入用户名称"
          style="width: 200px"
        />
      </div>

      <div class="screen-box">
        <div class="screen-label">登录账户</div>
        <a-input
          v-model="r_username"
          allowClear
          placeholder="请输入登录账户"
          style="width: 200px"
        />
      </div>

      <div class="screen-box">
        <div class="screen-label">角色</div>
        <a-select
          mode="multiple"
          style="width: 300px"
          placeholder="请选择"
          @change="handleChangeA"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
        >
          <!-- 这里的value用key是因为有重名的，有重名的内容就会报错，所以用key，key是唯一的 -->
          <a-select-option
            v-for="(item, key) in roleList"
            :key="key"
            :value="key"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </div>

      <div class="screen-box">
        <div class="screen-label">账户状态</div>
        <a-select
          style="width: 200px"
          placeholder="请选择"
          @change="handleChangeStatus"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
        >
          <!-- 这里的value用key是因为有重名的，有重名的内容就会报错，所以用key，key是唯一的 -->
          <a-select-option
            v-for="(item, index) in statusList"
            :key="index"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>

      <a-button
        @click="searchButton"
        :loading="search_button_loading"
        type="primary"
        icon="search"
        style="margin-right: 20px"
      >
        搜索
      </a-button>
      <a-button
        @click="addButton"
        style="background-color: #67c23a; border-color: #67c23a"
        type="primary"
      >
        + 新增
      </a-button>
    </div>

    <div>
      <!-- 表头 -->
      <div class="table-th" :style="{ width: table_scroll_width + 'px' }">
        <div v-for="(item, index) in rableTitle" :key="index">
          <div class="table-th-cell" :style="{ width: item.width + 'px' }">
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in tableShowData"
        :key="index"
        class="table-td"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <template v-for="(z_tem, z_ndex) in rableTitle">
          <div
            v-if="
              z_tem.type != 'role' &&
              z_tem.type != 'data_access' &&
              z_tem.type != 'cz' &&
              z_tem.type != 'status'
            "
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item[z_tem.type] }}
          </div>
          <div
            v-else-if="z_tem.type == 'status'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item.status == 1 ? "在职" : "离职" }}
          </div>
          <div
            v-else-if="z_tem.type == 'role'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            <div
              v-for="(t_item, t_index) in item.role"
              :key="t_index"
              class="tags"
            >
              {{ t_item }}
            </div>
          </div>
          <div
            v-else-if="z_tem.type == 'data_access'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            <div
              v-for="(t_item, t_index) in item.data_access"
              :key="t_index"
              class="tags"
            >
              {{ t_item.type | accessFilters }}(近{{ t_item.day }}天)
            </div>
          </div>
          <div
            v-else-if="z_tem.type == 'cz'"
            class="table-td-cell"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
            style="font-size: 12px; display: flex; flex-wrap: wrap"
          >
            <div
              @click="editTable(index, item.id)"
              style="color: #62a8ea; cursor: pointer; margin-right: 7px"
            >
              修改用户信息
            </div>
            <div
              @click="editAccess(index, item)"
              style="color: #62a8ea; cursor: pointer"
            >
              管理数据权限
            </div>
          </div>
        </template>
      </div>

      <div
        v-show="tableShowData.length === 0"
        style="text-align: center; text-align: center; padding: 80px 0 50px"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <a-icon style="font-size: 70px; color: #999" type="file-search" />

        <div style="color: #999; font-size: 16px; margin-top: 20px">
          内容为空
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div
      :style="{ width: table_scroll_width + 'px' }"
      style="text-align: center; margin-top: 30px"
    >
      <a-pagination
        v-model="r_page"
        :pageSize="20"
        :total="table_total"
        @change="paginationChange"
        hideOnSinglePage
      />
    </div>

    <!-- 新增/编辑的侧边栏 -->
    <a-drawer
      :title="'设置用户信息'"
      width="600px"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onCloseDrawer"
    >
      <div style="padding: 10px">
        <div class="form-cell-box">
          <div class="class-title">
            用户名称
            <span class="required-hint">*</span>
          </div>

          <a-input v-model="x_name" placeholder="请输入" style="width: 300px" />
        </div>

        <!-- <div class="form-cell-box">
				<div class="class-title">角色</div>
					
				<a-input v-model="x_roles" placeholder="请输入" style="width: 240px;"  />
			</div> -->
        <div class="form-cell-box">
          <div class="class-title">
            角色
            <span class="required-hint">*</span>
          </div>
          <a-select
            :value="x_roles"
            mode="multiple"
            style="width: 300px"
            placeholder="请选择"
            @change="handleChangeB"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
          >
            <!-- 这里的value用key是因为有重名的，有重名的内容就会报错，所以用key，key是唯一的 -->
            <a-select-option
              v-for="(item, key) in roleList"
              :key="key"
              :value="key"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </div>

        <div class="form-cell-box">
          <div class="class-title">
            登录账户
            <span class="required-hint">*</span>
          </div>

          <a-input
            v-model="x_username"
            placeholder="请输入"
            style="width: 300px"
          />
        </div>

        <div class="form-cell-box">
          <div class="class-title">
            登录密码
            <span v-show="drawer_title === '新增'" class="required-hint">
              *
            </span>
          </div>

          <a-input-password
            v-model="x_password"
            placeholder="请输入"
            style="width: 300px"
          />
        </div>

        <div class="form-cell-box">
          <div class="class-title">
            确认登录密码
            <span v-show="drawer_title === '新增'" class="required-hint">
              *
            </span>
          </div>

          <a-input-password
            v-model="x_password_confirmation"
            placeholder="请输入"
            style="width: 300px"
          />
        </div>

        <div class="form-cell-box">
          <div class="class-title">
            常用登录城市
            <span class="required-hint">*</span>
          </div>

          <a-input v-model="x_city" placeholder="请输入" style="width: 300px" />
        </div>

        <div style="display: flex; margin-bottom: 20px; margin-top: -15px">
          <div style="width: 100px; text-align: right; margin-right: 25px">
            提交格式--英逗号做分隔：
          </div>
          <div>
            <div>长沙</div>
            <div>长沙,北京</div>
            <div>长沙,北京,杭州</div>
          </div>
        </div>

        <div class="form-cell-box">
          <div class="class-title">
            账户状态
            <span class="required-hint">*</span>
          </div>

          <a-select
            style="width: 300px"
            placeholder="请选择"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
            v-model="x_status"
          >
            <!-- 这里的value用key是因为有重名的，有重名的内容就会报错，所以用key，key是唯一的 -->
            <a-select-option
              v-for="(item, index) in statusList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>

        <div class="form-cell-box">
          <div class="class-title">绩效密码</div>

          <a-input-password
            v-model="x_reward_password"
            placeholder="请输入"
            style="width: 300px"
          />
        </div>

        <div class="form-cell-box">
          <div class="class-title">确认绩效密码</div>

          <a-input-password
            v-model="x_reward_password_confirmation"
            placeholder="请输入"
            style="width: 300px"
          />
        </div>

        <div style="color: red; height: 23px; width: 100%">
          {{ add_form_hint }}
        </div>

        <div class="form-cell-box" style="margin-top: 30px; padding-left: 41px">
          <a-button
            @click="addRequest"
            :loading="add_button_loading"
            type="primary"
            style="margin-right: 20px"
          >
            确认
          </a-button>
          <a-button @click="onCloseDrawer">取消</a-button>
        </div>
      </div>
    </a-drawer>

    <accessDrawer
      ref="refAccessDrawer"
      @access-loading-handle="accessLoadingHandle"
      @access-success-handle="accessSuccessHandle"
    ></accessDrawer>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import accessDrawer from "./component/userAccessDrawer.vue";
import {
  manageUser,
  UserSelectRole,
  UserEdit,
  UserAdd,
  UserInfo,
  UserDataAccess,
} from "@/request/api";
export default {
  name: "users_",
  components: {
    accessDrawer,
  },
  data() {
    return {
      // 表格部分内容
      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        { title: "ID", width: 80, type: "id" }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
        { title: "用户名称", width: 120, type: "name" },
        { title: "登录账户", width: 160, type: "username" },
        { title: "角色", width: 170, type: "role" },
        { title: "常用登录城市", width: 140, type: "city" },
        { title: "账户状态", width: 80, type: "status" },
        { title: "数据权限", width: 160, type: "data_access" },
        { title: "操作", width: 160, type: "cz" },
        // {title:"路由权限", width:100, type:"ck", },
        { title: "创建时间", width: 150, type: "created_at" },
        { title: "更新时间", width: 150, type: "updated_at" },
      ],
      tableShowData: [],
      table_scroll_width: 1600,

      search_button_loading: false,
      r_id: null,
      r_name: null,
      r_username: null,
      r_roles: undefined,
      r_status: undefined,
      r_page: 1,
      table_total: 0,

      drawer_title: "新增", // 侧边栏标题
      visible: false,
      add_button_loading: false, // 新增侧边栏的确认按钮加载状态
      add_form_hint: "", // 侧边栏新增表单的验证提示
      // 新增/编辑参数
      x_id: undefined, // id
      x_username: "", // 用户名
      x_name: "", // 名称
      x_roles: undefined, // 角色
      x_city: "", // 常用登录城市
      x_password: "", // 登录密码
      x_password_confirmation: "", // 确认登录密码
      x_reward_password: "", // 绩效密码
      x_reward_password_confirmation: "", // 确认绩效密码
      x_status: undefined,
      roleList: {}, // 角色下拉列表
      statusList: [
        {
          name: "在职",
          value: 1,
        },
        {
          name: "离职",
          value: 0,
        },
      ], //账户状态
    };
  },
  beforeMount() {
    if (this.$route.query.id) {
      this.r_id = this.$route.query.id;
    }
  },
  mounted() {
    let that = this;

    // 获取表格信息
    let table_info = this.$getTableInfo(that.rableTitle);
    that.table_scroll_width = table_info.table_width;

    that.searchButton();

    UserSelectRole().then((res) => {
      console.log("角色下拉列表", res.data.data.list);
      let data = res.data.data.list;
      let k_data = Object.keys(data);
      let r_data = [];
      k_data.forEach((res) => {
        let obj = {
          key: res,
          value: data[res],
        };
        r_data.push(obj);
      });
      that.roleList = res.data.data.list;
    });
  },
  methods: {
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeA(value) {
      this.r_roles = value;
    },

    handleChangeStatus(value) {
      this.r_status = value;
    },
    // 角色下拉
    handleChangeB(value) {
      this.x_roles = value;
      console.log(value);
    },

    // 搜索
    searchButton() {
      let that = this;

      that.search_button_loading = true;

      manageUser({
        page: that.r_page,
        name: that.r_name,
        id: that.r_id,
        username: that.r_username,
        role_id: that.r_roles,
        status: that.r_status,
      }).then((res) => {
        console.log("列表结果", res.data.data);
        that.search_button_loading = false;
        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("搜索成功");
          that.table_total = res.data.data.total;
          that.tableShowData = res.data.data.data;
        } else {
          if (res.data.code === 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`其他错误：${res.data.msg}`);
          }
        }
      });
    },
    // 新增
    addButton() {
      let that = this;
      that.drawer_title = "新增";
      that.visible = true;
    },
    // 编辑
    editTable(index, id) {
      let that = this;
      that.drawer_title = "编辑";
      that.x_id = id;
      UserInfo({ id }).then((res) => {
        console.log("获取信息", res.data.data.info);
        let info = res.data.data.info;
        (that.x_id = info.id || undefined), // id
          (that.x_username = info.username || ""), // 用户名
          (that.x_name = info.name || ""), // 名称
          (that.x_city = info.city || ""); // 常用登录城市
        that.x_status =
          info.status || info.status === 0 ? info.status : undefined;

        let role_data = info.role || {};
        let k_data = Object.keys(role_data);
        let kk_data = [];
        k_data.forEach((res) => {
          kk_data.push(res);
        });
        console.log("kk_data", kk_data);
        that.x_roles = kk_data || undefined; // 角色

        that.visible = true;
      });
    },
    // 管理数据权限
    editAccess(index, item) {
      let that = this;
      // console.log("item", item);
      that.$refs.refAccessDrawer.showDrawer(item);
    },

    // 查看权限
    showPermissions() {
      let that = this;
    },
    // 侧边栏的新增/编辑
    addRequest() {
      let that = this;
      if (!that.x_username) {
        // 用户名
        that.add_form_hint = "请填写 用户名 ！！！";
      } else if (!that.x_name) {
        // 名称
        that.add_form_hint = "请填写 名称 ！！！";
      } else if (!that.x_roles) {
        // 角色
        that.add_form_hint = "请填写 角色 ！！！";
      } else if (!that.x_city) {
        // 常用登录城市
        that.add_form_hint = "请填写 常用登录城市 ！！！";
      } else if (!that.x_status && that.x_status !== 0) {
        // 常用登录城市
        that.add_form_hint = "请选择 账户状态 ！！！";
      } else if (!that.x_password && that.drawer_title === "新增") {
        // 登录密码
        that.add_form_hint = "请填写 登录密码 ！！！";
      } else if (
        !that.x_password_confirmation &&
        that.drawer_title === "新增"
      ) {
        // 确认登录密码
        that.add_form_hint = "请填写 确认登录密码 ！！！";
      }
      // 检查密码和确认密码是否一致
      else if (
        that.x_password &&
        that.x_password != that.x_password_confirmation
      ) {
        that.add_form_hint = "两次密码输入不一致";
      }
      // else if(!that.x_reward_password){ // 绩效密码
      // 	that.add_form_hint = "请填写 绩效密码 ！！！"
      // }
      // else if(!that.x_reward_password_confirmation){ // 确认绩效密码
      // 	that.add_form_hint = "请填写 确认绩效密码 ！！！"
      // }
      // 检查绩效密码和确认绩效密码是否一致
      else if (
        that.x_reward_password &&
        that.x_reward_password != that.x_reward_password_confirmation
      ) {
        that.add_form_hint = "两次绩效密码输入不一致";
      } else {
        that.add_form_hint = "";
        that.add_button_loading = true;
        let r_data = {
          id: that.x_id,
          username: that.x_username,
          name: that.x_name,
          password: that.x_password,
          password_confirmation: that.x_password_confirmation,
          reward_password: that.x_reward_password,
          reward_password_confirmation: that.x_reward_password_confirmation,
          city: that.x_city,
          status: that.x_status,
          roles: that.x_roles,
        };
        if (that.drawer_title === "新增") {
          UserAdd(r_data)
            .then((res) => {
              console.log("新增", res);
              that.add_button_loading = false;

              if (
                res.data.code == 0 ||
                res.data.code == 200 ||
                res.data.code == 8011
              ) {
                that.onCloseDrawer();
                that.$message.success("新增成功");
                that.searchButton();
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                  return;
                }
                that.$message.error(res.data.msg || "新增失败");
              }
            })
            .catch((err) => {
              console.log(err);
              that.$message.error("新增失败，可能是网络出现问题");
            });
        } else if (that.drawer_title === "编辑") {
          UserEdit(r_data)
            .then((res) => {
              console.log("编辑", res);
              that.add_button_loading = false;
              if (
                res.data.code == 0 ||
                res.data.code === 200 ||
                res.data.code == 8011
              ) {
                that.onCloseDrawer();
                that.$message.success("编辑成功");
                that.searchButton();
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                  return;
                }
                that.$message.error(res.data.msg || "编辑失败");
              }
            })
            .catch((err) => {
              console.log(err);
              that.$message.error("编辑失败，可能是网络出现问题");
            });
        }
      }
    },
    // 侧边栏关闭
    onCloseDrawer() {
      if (this.add_button_loading) {
        // 新增中或编辑中不准关闭侧边栏
        return;
      }
      this.visible = false;
      (this.x_username = ""), // 用户名
        (this.x_name = ""), // 名称
        (this.x_roles = undefined), // 角色
        (this.x_city = ""), // 常用登录城市
        (this.x_password = ""), // 登录密码
        (this.x_password_confirmation = ""), // 确认登录密码
        (this.x_reward_password = ""), // 绩效密码
        (this.x_reward_password_confirmation = ""); // 确认绩效密码
      this.add_form_hint = "";
      this.x_status = undefined;
    },

    // 分页
    paginationChange(e) {
      let that = this;
      this.r_page = e;
      that.searchButton();
    },

    accessLoadingHandle(e) {
      this.search_button_loading = e;
    },
    accessSuccessHandle() {
      this.searchButton();
    },
  },
  filters: {
    accessFilters(e) {
      // 数据权限类型：1=投放跟踪:搜索日期范围，2=数据看板:搜索日期范围，3=公众号订单:搜索日期范围，4=投放跟踪:后续Dn留存天数
      const map = {
        1: "推广效果跟踪-日期范围",
        2: "推广数据看板",
        3: "公众号订单",
        4: "推广效果跟踪-后续Dn留存天数",
        5:"巨量看板-搜索日期范围"
      };
      return map[e] || "其他";
      // if (e == 1) {
      //   fff = "推广效果跟踪";
      // } else if (e == 2) {
      //   fff = "推广数据看板";
      // } else if (e == 3) {
      //   fff = "公众号订单";
      // } else {
      //   fff = "其他";
      // }
      // return fff;
    },
  },
};
</script>

<style scoped>
.page-title {
  text-align: left;
  font-weight: 500;
  font-size: 24px;
}

.screen-box {
  display: flex;
  align-items: center;
  margin-right: 30px;
  /* margin-bottom: 25px; */
}
.screen-label {
  min-width: 56px;
  flex-shrink: 0;
  margin-right: 15px;
}

.form-cell-box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.class-title {
  position: relative;
  font-size: 14px;
  margin-right: 25px;
  width: 100px;
  color: #333;
  text-align: right;
}

.tags {
  display: inline-block;
  color: #fff;
  background-color: #62a8ea;
  padding: 1px 5px;
  border-radius: 3px;
  text-align: center;
  margin-right: 5px;
  margin-bottom: 5px;
}

.loading-box {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 111;
  text-align: center;
  line-height: 100vh;
}

/* 必填提示 */
.required-hint {
  color: red;
  position: absolute;
  right: -8px;
}

.screen-box {
  margin-bottom: 10px;
}
</style>
